import dayjs from '../../utils/dayjs';
import { Page, DataTable, Link, Text, Card, Tooltip, BlockStack } from '@shopify/polaris';
import { useCallback, useEffect, useMemo, useState } from 'react';

import helpers from 'helpers/index';
import Pagination from 'components/pagination';
import { Helmet } from 'react-helmet-async';
import { ___ } from 'languages/index';
import { ENUM_ORDER_PAYMENT_STATUS, ENUM_ORDER_STATUS, TypedOrders, useGetOrders } from 'queries/orders.query';
import OrdersFilter from './filter';
import { getOrderStatus } from './order.util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircle, faDotCircle } from '@fortawesome/free-solid-svg-icons';

export default function OrderList() {
  const rootSearchPath = window.location.search;
  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let StringQuery: any = helpers.ExtractUrl(rootSearchPath) || false;
  const initialQuery = {
    query: '',
    page: 1,
    limit: 50,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState<any>({
    ...initialQuery,
    ...StringQuery,
  });
  const { refetch: getEntities, data, isFetching: loading } = useGetOrders(mainQuery);

  const [entities, setEntities] = useState<TypedOrders[]>([]);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    if (data) {
      let { entities, totalItems } = data;
      setEntities(entities);
      setTotalItems(totalItems);
    }
  }, [data]);

  const totalInTable = useMemo(() => {
    return entities.reduce(
      (total, order) => ({
        totalOrder: total.totalOrder + 1,
        totalSeat: total.totalSeat + (Number(order.total_seat) || 0),
        totalFee: total.totalFee + (Number(order.total_fee) || 0),
        totalMustPay: total.totalMustPay + (Number(order.total_must_pay) || 0),
      }),
      { totalOrder: 0, totalSeat: 0, totalFee: 0, totalMustPay: 0 }
    );
  }, [entities]);

  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) {
      window.history.replaceState(null, 'Orders', '/orders' + buildURLSearch);
    }
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  const styles: any = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    width: '200px',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    overflow: 'auto',
  };

  return (
    <>
      <Helmet>
        <title>Danh sách đơn hàng</title>
      </Helmet>
      <Page
        title="Danh sách đơn hàng"
        fullWidth
        // primaryAction={{
        //   content: 'Thêm vé',
        //   icon: PlusIcon,
        //   onAction: () => toggleCreateModalActive(),
        // }}
      >
        <Card padding="0">
          <OrdersFilter loading={loading} onCallback={filterCallback} />
          <DataTable
            verticalAlign="middle"
            hideScrollIndicator={true}
            stickyHeader
            increasedTableDensity
            columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
            headings={[
              'Code',
              'Khách hàng',
              'T.toán',
              'H.Đơn',
              'Vận chuyển',
              'Ngày đi',
              'Hành trình',
              'Vé',
              'Phí',
              'T.tiền',
              'Người đón',
              'Người trả',
              'Điểm đón trả',
              'Ghi chú',
              'Người đặt',
              'Ngày tạo',
            ]}
            showTotalsInFooter
            totals={[
              'Tổng',
              `${totalInTable.totalOrder} đơn`,
              '',
              '',
              '',
              '',
              totalInTable.totalSeat,
              helpers.formatNumber(totalInTable.totalFee),
              helpers.formatNumber(totalInTable.totalMustPay),
              '',
              '',
              '',
              '',
              '',
              '',
              '',
            ]}
            totalsName={{ singular: 'Tổng', plural: 'Tổng' }}
            rows={
              entities?.map((order) => {
                const {
                  id,
                  order_code,
                  pickup_time,
                  customer_data,
                  departure_date,
                  dropoff_address,
                  pickup_address,
                  pickup_note,
                  dropoff_note,
                  journey,
                  total_must_pay,
                  note,
                  author_data,
                  order_status,
                  total_seat,
                  total_fee,
                  payment_status,
                  journey_id,
                  createdAt,

                  invoices,

                  order_meta,
                } = order;

                let trip_date_reformat = dayjs(new Date(Number(departure_date))).format('YYYY-MM-DD');
                return [
                  //   <Link
                  //     removeUnderline
                  //     // url={`#order_id:${id}`}
                  //   >
                  //     <strong>{order_code}</strong>
                  //   </Link>,
                  <Link
                    removeUnderline
                    // url={`#order_id:${id}`}
                    url={`/orders/view/${id}`}
                  >
                    <strong>{order_code}</strong>
                  </Link>,
                  customer_data ? (
                    <>
                      <Link removeUnderline url={`/customer/view/${customer_data?.user_id}`}>
                        <Tooltip content={customer_data?.display_name}>
                          <p style={{ ...styles, maxWidth: '100px', fontWeight: 'bold' }}>{customer_data?.display_name}</p>
                        </Tooltip>
                      </Link>
                      {customer_data?.user_phonenumber && (
                        <Link url={`tel:${customer_data?.user_phonenumber}`}>
                          <Text as="p">{customer_data?.user_phonenumber}</Text>
                        </Link>
                      )}
                    </>
                  ) : (
                    '--'
                  ),

                  order_status === ENUM_ORDER_STATUS.CANCELLED ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--card2)" />
                  ) : payment_status === ENUM_ORDER_PAYMENT_STATUS.PAID ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--green2)" />
                  ) : payment_status === ENUM_ORDER_PAYMENT_STATUS.PARTIALLY_PAID ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--p-color-icon-caution)" />
                  ) : (
                    <FontAwesomeIcon icon={faCircle} color="var(--bad)" />
                  ),

                  order_status === ENUM_ORDER_STATUS.CANCELLED ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--card2)" />
                  ) : !invoices ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--bad)" />
                  ) : (
                    <FontAwesomeIcon icon={faCircle} color="var(--green2)" />
                  ),

                  getOrderStatus(order_status),

                  <>
                    <Text as="h3" variant="headingMd">
                      {pickup_time}
                    </Text>
                    <Text as="p" tone="subdued">
                      {trip_date_reformat}
                    </Text>
                  </>,
                  journey ? <Text as="span">{journey?.journey_name}</Text> : '--',
                  total_seat,
                  helpers.formatNumber(total_fee),
                  helpers.formatNumber(total_must_pay),

                  order_meta?.pickup_by_data?.display_name || '',
                  order_meta?.dropoff_by_data?.display_name || '',

                  <BlockStack>
                    <Text as="p">{pickup_address || ''}</Text>
                    {String(pickup_note || '').trim() !== '' ? (
                      <Text as="p" variant="bodySm" tone="critical">
                        {pickup_note}
                      </Text>
                    ) : null}
                    <Text as="p">{dropoff_address || '-'}</Text>
                    {String(dropoff_note || '').trim() !== '' ? (
                      <Text as="p" variant="bodySm" tone="critical">
                        {dropoff_note}
                      </Text>
                    ) : null}
                  </BlockStack>,

                  note ? (
                    <Tooltip content={note}>
                      <p style={styles}>{note}</p>
                    </Tooltip>
                  ) : (
                    '--'
                  ),
                  author_data?.display_name ?? '--',

                  <>
                    <Text as="h3" variant="headingMd">
                      {dayjs(new Date(Number(createdAt))).format('HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dayjs(new Date(Number(createdAt))).format('DD-MM-YYYY')}
                    </Text>
                  </>,
                ];
              }) || []
            }
            footerContent={___('Show page {display_page_number} of {total_record_number} results', {
              display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
              total_record_number: <Text as="strong">{totalItems}</Text>,
            })}
          />
        </Card>

        <br />
        {totalItems > 0 ? (
          <Pagination
            TotalRecord={totalItems}
            onChange={onChangePagination}
            pageSize={Number(mainQuery?.limit)}
            activeCurrentPage={Number(mainQuery?.page)}
          />
        ) : null}
      </Page>
      <br />
      <br />
      <br />
      <br />
    </>
  );
}
